import Structure from '../modules/structure';

$.fn.mobileFilterControlsScript = function() {

    var jqAllAffectedContainers = this;

    jqAllAffectedContainers.each(function() {
        const container = $(this);
        const structure = new Structure('filterGroupsCollapsabale', container, {
            filterBtn: ".filter-toggle>a",
            filterGroups: ".filter-groups"
        }).structure;
        structure.filterBtn.on('click', function(e) {
            e.preventDefault();
            if (structure.filterBtn.hasClass('open')) {
                structure.filterBtn.removeClass('open');
                structure.filterGroups.removeClass('open');
            } else {
                structure.filterBtn.addClass('open');
                structure.filterGroups.addClass('open');
            }
        }); 
    });

    return this;
};

document.fonts.ready.then(function () {
    $('.mobile-filter-controls-js').mobileFilterControlsScript();
});
